import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { GraphicalMapService } from './graphical-map.service';

export const Ng1GraphicalMapModule = angular
  .module('control-room.shared.services.graphical-map', [])
  .factory('crGraphicalMapService', downgradeInjectable(GraphicalMapService));